import { SortDirection } from '@angular/material/sort';
import { IncidentStatus } from '@app/enums/incident-status';
import { IncidentModel } from '@app/models/incident.model';
import { IncidentsFilters } from '@app/types/incidents-filters';

export class LoadIncidents {
  static readonly type = '[Incidents] Load Incidents';
  constructor(
    public payload?: {
      filters?: IncidentsFilters;
      pageNumber?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection: SortDirection;
    },
  ) {}
}

export class ResetIncidentsList {
  static readonly type = '[Incidents] Reset Incidents list';
}

export class LoadIncident {
  static readonly type = '[Incidents] Load incident';
  constructor(public payload: { incidentId: string }) {}
}

export class ResetActiveIncident {
  static readonly type = '[Incident] Reset active incident';
}

export class UpdateIncident {
  static readonly type = '[Incident] Update Incident';
  constructor(public payload: { incident: IncidentModel }) {}
}

export class UpdateIncidentStatus {
  static readonly type = '[Incident] Update Incident Status';
  constructor(public payload: { status: IncidentStatus }) {}
}
